<div class="grid grid-cols-1 min-[1100px]:grid-cols-4 gap-4 mt-6">
  <div *ngFor="let data of array(amountCol); let colIndex = index">
    <div
      *ngFor="
        let rowItem of array(math.ceil(dataCategory[currentIndex].length / amountCol));
        let rowIndex = index
      "
    >
      <div *ngIf="getMenu(rowIndex, colIndex)">
        <div class="block w-full min-[1100px]:w-[220px] mb-6">
          <div>
            <div
              class="font-bold text-base mb-4 cursor-pointer"
              (click)="redirectToPage(getMenu(rowIndex, colIndex))"
            >
              {{ getMenu(rowIndex, colIndex).type }}
            </div>

            <div>
              <ng-container *ngFor="let menu of getMenu(rowIndex, colIndex).values; let i = index">
                <div
                  *ngIf="i < 6 || mapStatusOpenedMenu.get(getMenu(rowIndex, colIndex).type)"
                  class="text-sm text-[rgba(92,100,125,1)] leading-[19.6px] noBorderLink cursor-pointer w-fit mb-2.5"
                  (click)="redirectToPage(getMenu(rowIndex, colIndex), menu)"
                >
                  {{ menu.name }}
                </div>
              </ng-container>

              <ng-container *ngIf="!mapStatusOpenedMenu.get(getMenu(rowIndex, colIndex).type)">
                <button
                  *ngIf="getMenu(rowIndex, colIndex).values.length - 6 > 0"
                  pButton
                  class="p-button-text !p-0 text-base w-fit"
                  (click)="setNewValue(getMenu(rowIndex, colIndex).type)"
                >
                  Еще
                  {{ getMenu(rowIndex, colIndex).values.length - 6 }}
                  <span
                    *clientSideRendering
                    class="fillColor"
                    inlineSVG="/assets/icons/header/category/arrowDown.svg"
                  ></span>
                </button>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
